var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../../../Icon";
import * as S from "./Checkbox.styled";
export var Radio = function (_a) {
    var checked = _a.checked, error = _a.error, fieldProps = __rest(_a, ["checked", "error"]);
    return (_jsxs(S.Checkbox, { checked: checked, error: error, children: [_jsx("input", __assign({ onChange: function () { }, checked: checked }, fieldProps)), _jsx(Icon, { source: "radioButtonOutline" }), checked && _jsx(Icon, { source: "radioButtonMark" })] }));
};
